var neighborhoodCityState = function neighborhoodCityState(address) {
  var _state$uf;
  var city = address.city,
    neighborhood = address.neighborhood;
  var _ref = city != null ? city : {},
    name = _ref.name,
    state = _ref.state;
  return neighborhood + ", " + name + " - " + ((_state$uf = state == null ? void 0 : state.uf) != null ? _state$uf : '') + " ";
};
var streetNumberNeighborhood = function streetNumberNeighborhood(address) {
  var street = address.street,
    number = address.number,
    complement = address.complement,
    neighborhood = address.neighborhood;
  return street + ", " + number + (complement ? ", " + complement : '') + " - " + neighborhood;
};
var streetAndNumber = function streetAndNumber(address) {
  var street = address.street,
    number = address.number,
    complement = address.complement;
  return street + ", " + number + (complement ? ", " + complement : '');
};

var OpenCloseBehavior;
(function (OpenCloseBehavior) {
  OpenCloseBehavior["automatic"] = "automatic";
  OpenCloseBehavior["manual"] = "manual";
  OpenCloseBehavior["alwaysManual"] = "alwaysManual";
})(OpenCloseBehavior || (OpenCloseBehavior = {}));

var CardFlagsType;
(function (CardFlagsType) {
  CardFlagsType["Visa"] = "Visa";
  CardFlagsType["MasterCard"] = "MasterCard";
  CardFlagsType["AmericanExpress"] = "American Express";
  CardFlagsType["DiscoverNetwork"] = "Discover Network";
  CardFlagsType["Maestro"] = "Maestro";
  CardFlagsType["Hiper"] = "Hiper";
  CardFlagsType["HiperCard"] = "HiperCard";
  CardFlagsType["DinersClub"] = "Diners Club";
  CardFlagsType["Elo"] = "Elo";
  CardFlagsType["Alelo"] = "Alelo";
  CardFlagsType["Sodexo"] = "Sodexo";
  CardFlagsType["Ticket"] = "Ticket";
  CardFlagsType["ValeCard"] = "ValeCard";
  CardFlagsType["VeroCheque"] = "VeroCheque";
  CardFlagsType["NutriCard"] = "NutriCard";
  CardFlagsType["others"] = "others";
})(CardFlagsType || (CardFlagsType = {}));

var CashFlowStatus;
(function (CashFlowStatus) {
  CashFlowStatus["open"] = "open";
  CashFlowStatus["closed"] = "closed";
})(CashFlowStatus || (CashFlowStatus = {}));

var MovementType;
(function (MovementType) {
  MovementType["entry"] = "entry";
  MovementType["outflow"] = "outflow";
})(MovementType || (MovementType = {}));
var OperationType;
(function (OperationType) {
  OperationType["order"] = "order";
  OperationType["manually"] = "manually";
  OperationType["initialCash"] = "initialCash";
})(OperationType || (OperationType = {}));

var CategoryOperationMethod;
(function (CategoryOperationMethod) {
  CategoryOperationMethod["default"] = "default";
  CategoryOperationMethod["schedule"] = "schedule";
})(CategoryOperationMethod || (CategoryOperationMethod = {}));
var CategoryType;
(function (CategoryType) {
  CategoryType["item"] = "item";
  CategoryType["pizza"] = "pizza";
})(CategoryType || (CategoryType = {}));

var BotStatus;
(function (BotStatus) {
  BotStatus["activated"] = "activated";
  BotStatus["deactivated"] = "deactivated";
})(BotStatus || (BotStatus = {}));

var ConfirmationStatus;
(function (ConfirmationStatus) {
  ConfirmationStatus["pending"] = "pending";
  ConfirmationStatus["approved"] = "approved";
  ConfirmationStatus["rejected"] = "rejected";
})(ConfirmationStatus || (ConfirmationStatus = {}));

var DeliveryType;
(function (DeliveryType) {
  DeliveryType["delivery"] = "delivery";
  DeliveryType["takeout"] = "takeOut";
})(DeliveryType || (DeliveryType = {}));

var VehicleType;
(function (VehicleType) {
  VehicleType["bicycle"] = "bicycle";
  VehicleType["car"] = "car";
  VehicleType["motorcycle"] = "motorcycle";
})(VehicleType || (VehicleType = {}));

var DeliveryFeeType;
(function (DeliveryFeeType) {
  DeliveryFeeType["fixedFee"] = "fixedFee";
  DeliveryFeeType["neighborhoodFee"] = "neighborhoodFee";
  DeliveryFeeType["mapRoute"] = "mapRoute";
  DeliveryFeeType["mapStraight"] = "mapStraight";
  DeliveryFeeType["mapArea"] = "mapArea";
})(DeliveryFeeType || (DeliveryFeeType = {}));

var DiscountCodeStatus;
(function (DiscountCodeStatus) {
  DiscountCodeStatus["activated"] = "activated";
  DiscountCodeStatus["deactivated"] = "deactivated";
  DiscountCodeStatus["notStarted"] = "notStarted";
  DiscountCodeStatus["expired"] = "expired";
  DiscountCodeStatus["depleted"] = "depleted";
})(DiscountCodeStatus || (DiscountCodeStatus = {}));
var DiscountValueType;
(function (DiscountValueType) {
  DiscountValueType["percentage"] = "percentage";
  DiscountValueType["value"] = "value";
})(DiscountValueType || (DiscountValueType = {}));
var DiscountCodeType;
(function (DiscountCodeType) {
  DiscountCodeType["generic"] = "generic";
  DiscountCodeType["personal"] = "personal";
  DiscountCodeType["firstPurchase"] = "firstPurchase";
})(DiscountCodeType || (DiscountCodeType = {}));
var DiscountTarget;
(function (DiscountTarget) {
  DiscountTarget["cart"] = "cart";
  DiscountTarget["deliveryFee"] = "deliveryFee";
})(DiscountTarget || (DiscountTarget = {}));

var DocumentType;
(function (DocumentType) {
  DocumentType["cpf"] = "cpf";
  DocumentType["cnpj"] = "cnpj";
})(DocumentType || (DocumentType = {}));

var DeliveryStatusTypes;
(function (DeliveryStatusTypes) {
  DeliveryStatusTypes["Activated"] = "activated";
  DeliveryStatusTypes["Deactivated"] = "deactivated";
})(DeliveryStatusTypes || (DeliveryStatusTypes = {}));
var TypeCardFlag;
(function (TypeCardFlag) {
  TypeCardFlag["debit"] = "debit";
  TypeCardFlag["credit"] = "credit";
  TypeCardFlag["voucher"] = "voucher";
})(TypeCardFlag || (TypeCardFlag = {}));
var PaymentSettingsTypes;
(function (PaymentSettingsTypes) {
  PaymentSettingsTypes["debitCardFlags"] = "debitCardFlags";
  PaymentSettingsTypes["creditCardFlags"] = "creditCardFlags";
  PaymentSettingsTypes["voucherCardFlags"] = "voucherCardFlags";
})(PaymentSettingsTypes || (PaymentSettingsTypes = {}));
var ItemDisplayModeInCategory;
(function (ItemDisplayModeInCategory) {
  ItemDisplayModeInCategory["closed"] = "closed";
  ItemDisplayModeInCategory["open"] = "open";
})(ItemDisplayModeInCategory || (ItemDisplayModeInCategory = {}));
var MercadoPagoIntegrationsInfoStatus;
(function (MercadoPagoIntegrationsInfoStatus) {
  MercadoPagoIntegrationsInfoStatus["activated"] = "activated";
  MercadoPagoIntegrationsInfoStatus["deactivated"] = "deactivated";
  MercadoPagoIntegrationsInfoStatus["deleted"] = "deleted";
})(MercadoPagoIntegrationsInfoStatus || (MercadoPagoIntegrationsInfoStatus = {}));

var OnlinePaymentOrderBehavior;
(function (OnlinePaymentOrderBehavior) {
  OnlinePaymentOrderBehavior["hideOrdersWithPendingPayment"] = "hideOrdersWithPendingPayment";
  OnlinePaymentOrderBehavior["showOrdersWithPendingPayment"] = "showOrdersWithPendingPayment";
})(OnlinePaymentOrderBehavior || (OnlinePaymentOrderBehavior = {}));

var GenericStatus;
(function (GenericStatus) {
  GenericStatus["activated"] = "activated";
  GenericStatus["deactivated"] = "deactivated";
})(GenericStatus || (GenericStatus = {}));

var IntegrationStatus;
(function (IntegrationStatus) {
  IntegrationStatus["pending"] = "pending";
  IntegrationStatus["approved"] = "approved";
  IntegrationStatus["rejected"] = "rejected";
})(IntegrationStatus || (IntegrationStatus = {}));

var PaymentType;
(function (PaymentType) {
  PaymentType["cash"] = "cash";
  PaymentType["credit"] = "credit";
  PaymentType["debit"] = "debit";
  PaymentType["voucher"] = "voucher";
  PaymentType["pix"] = "pix";
  PaymentType["mercadoPago"] = "mercadoPago";
  PaymentType["ifoodVoucher"] = "ifoodVoucher";
  PaymentType["digitalWallet"] = "digitalWallet";
  PaymentType["shipay"] = "shipay";
  PaymentType["mercadoPagoCardPayment"] = "mercadoPagoCardPayment";
})(PaymentType || (PaymentType = {}));
var DigitalWalletType;
(function (DigitalWalletType) {
  DigitalWalletType["picPay"] = "picPay";
  DigitalWalletType["nuBank"] = "nuBank";
  DigitalWalletType["applePay"] = "applePay";
  DigitalWalletType["googlePay"] = "googlePay";
  DigitalWalletType["samsungPay"] = "samsungPay";
  DigitalWalletType["other"] = "other";
})(DigitalWalletType || (DigitalWalletType = {}));

var OrderItemProductionStatus;
(function (OrderItemProductionStatus) {
  OrderItemProductionStatus["pending"] = "pending";
  OrderItemProductionStatus["inProduction"] = "inProduction";
  OrderItemProductionStatus["ready"] = "ready";
  OrderItemProductionStatus["canceled"] = "canceled";
})(OrderItemProductionStatus || (OrderItemProductionStatus = {}));

var Step;
(function (Step) {
  Step["firstLogin"] = "first_login";
  Step["productGuide"] = "product_guide";
  Step["categoriesGuide"] = "categories_guide";
  Step["productRegistrationGuide"] = "product_registration_guide";
  Step["optionalFormGuide"] = "optional_form_guide";
  Step["logsGuide"] = "logs_guide";
  Step["couponsGuide"] = "coupons_guide";
  Step["couponsForm"] = "coupons_form_v2";
  Step["teamGuide"] = "team_guide";
  Step["panelGuide"] = "panel_guide";
  Step["qztrayGuide"] = "qztray_guide";
  Step["firstLoginRoute"] = "first_login_route";
  Step["desktopAndroidAppBannerV1"] = "desktop_android_app_banner_v1";
  Step["mobileAndroidAppBannerV1"] = "mobile_android_app_banner_v1";
  Step["pwPersons1"] = "pw_persons_1";
  Step["desktopOrdersAppBannerV1"] = "desktop_orders_app_banner_v1";
  Step["usesQz"] = "uses_qz";
  Step["nps"] = "nps";
  Step["letsEatY2Insta"] = "lets_eat_y2_insta";
  Step["letsEatY2Offer"] = "lets_eat_y2_offer";
  Step["permissions"] = "permissions";
  Step["survey"] = "survey";
  Step["cashFlowHistory"] = "cash_flow_history";
  Step["discountCodePageV2"] = "discount_code_page_v2";
  Step["deliveryMen"] = "delivery_men";
  Step["itemFormGuide"] = "item_form_guide";
  Step["catalogGuide"] = "catalog_guide";
  Step["categorySimpleFormGuide"] = "category_simple_form_guide";
  Step["categoryPizzaFormGuide"] = "category_pizza_form_guide";
  Step["uses8833"] = "uses_8833";
  Step["kdsHomeGuide"] = "kds_home_guide";
  Step["kdsBoardGuide"] = "kds_board_guide";
})(Step || (Step = {}));

var RedeemableStatus;
(function (RedeemableStatus) {
  RedeemableStatus["active"] = "active";
  RedeemableStatus["expired"] = "expired";
  RedeemableStatus["redeemed"] = "redeemed";
  RedeemableStatus["cancelled"] = "cancelled";
})(RedeemableStatus || (RedeemableStatus = {}));

var PersonLoyaltyPlanSortBy;
(function (PersonLoyaltyPlanSortBy) {
  PersonLoyaltyPlanSortBy["nameAsc"] = "nameAsc";
  PersonLoyaltyPlanSortBy["nameDesc"] = "nameDesc";
  PersonLoyaltyPlanSortBy["currentPointsAsc"] = "currentPointsAsc";
  PersonLoyaltyPlanSortBy["currentPointsDesc"] = "currentPointsDesc";
  PersonLoyaltyPlanSortBy["lastOrderAsc"] = "lastOrderAsc";
  PersonLoyaltyPlanSortBy["lastOrderDesc"] = "lastOrderDesc";
  PersonLoyaltyPlanSortBy["currentDeadLineAsc"] = "currentDeadLineAsc";
  PersonLoyaltyPlanSortBy["currentDeadLineDesc"] = "currentDeadLineDesc";
})(PersonLoyaltyPlanSortBy || (PersonLoyaltyPlanSortBy = {}));
var CompletedLoyaltyPlanSortBy;
(function (CompletedLoyaltyPlanSortBy) {
  CompletedLoyaltyPlanSortBy["nameAsc"] = "nameAsc";
  CompletedLoyaltyPlanSortBy["nameDesc"] = "nameDesc";
  CompletedLoyaltyPlanSortBy["deadLineAsc"] = "deadLineAsc";
  CompletedLoyaltyPlanSortBy["deadLineDesc"] = "deadLineDesc";
  CompletedLoyaltyPlanSortBy["totalSpentAsc"] = "totalSpentAsc";
  CompletedLoyaltyPlanSortBy["totalSpentDesc"] = "totalSpentDesc";
  CompletedLoyaltyPlanSortBy["statusAsc"] = "statusAsc";
  CompletedLoyaltyPlanSortBy["statusDesc"] = "statusDesc";
})(CompletedLoyaltyPlanSortBy || (CompletedLoyaltyPlanSortBy = {}));

var PointOrigin;
(function (PointOrigin) {
  PointOrigin["manual"] = "manual";
})(PointOrigin || (PointOrigin = {}));

var clientType;
(function (clientType) {
  clientType["whatsapp"] = "whatsapp";
  clientType["instagram"] = "instagram";
  clientType["facebook"] = "facebook";
  clientType["telegram"] = "telegram";
})(clientType || (clientType = {}));

var DayOfTheWeek;
(function (DayOfTheWeek) {
  DayOfTheWeek["sunday"] = "sunday";
  DayOfTheWeek["monday"] = "monday";
  DayOfTheWeek["tuesday"] = "tuesday";
  DayOfTheWeek["wednesday"] = "wednesday";
  DayOfTheWeek["thursday"] = "thursday";
  DayOfTheWeek["friday"] = "friday";
  DayOfTheWeek["saturday"] = "saturday";
})(DayOfTheWeek || (DayOfTheWeek = {}));
var OpenCloseHourStatus;
(function (OpenCloseHourStatus) {
  OpenCloseHourStatus["activated"] = "activated";
  OpenCloseHourStatus["deactivated"] = "deactivated";
})(OpenCloseHourStatus || (OpenCloseHourStatus = {}));

var ManualCloseMode;
(function (ManualCloseMode) {
  ManualCloseMode["nextOpeningDate"] = "nextOpeningDate";
  ManualCloseMode["nextClosingDate"] = "nextClosingDate";
  ManualCloseMode["manually"] = "manually";
})(ManualCloseMode || (ManualCloseMode = {}));
var ManualOpenMode;
(function (ManualOpenMode) {
  ManualOpenMode["nextOpeningDate"] = "nextOpeningDate";
  ManualOpenMode["nextClosingDate"] = "nextClosingDate";
  ManualOpenMode["manually"] = "manually";
})(ManualOpenMode || (ManualOpenMode = {}));
var IFoodState;
(function (IFoodState) {
  IFoodState["OK"] = "OK";
  IFoodState["WARNING"] = "WARNING";
  IFoodState["CLOSED"] = "CLOSED";
  IFoodState["ERROR"] = "ERROR";
})(IFoodState || (IFoodState = {}));

var OptionalOptionType;
(function (OptionalOptionType) {
  OptionalOptionType["option"] = "option";
  OptionalOptionType["item"] = "item";
})(OptionalOptionType || (OptionalOptionType = {}));
var StatusType;
(function (StatusType) {
  StatusType["activated"] = "activated";
  StatusType["deactivated"] = "deactivated";
})(StatusType || (StatusType = {}));
var TypeOption;
(function (TypeOption) {
  TypeOption["undefined"] = "";
  TypeOption["simple"] = "simple";
  TypeOption["selector"] = "selector";
  TypeOption["pizza"] = "pizza";
  TypeOption["edge"] = "edge";
  TypeOption["dough"] = "dough";
  TypeOption["size"] = "size";
})(TypeOption || (TypeOption = {}));
var ChargeType;
(function (ChargeType) {
  ChargeType["highest"] = "highest";
  ChargeType["average"] = "average";
})(ChargeType || (ChargeType = {}));

var OrderTimingType;
(function (OrderTimingType) {
  OrderTimingType["immediate"] = "immediate";
  OrderTimingType["scheduled"] = "scheduled";
})(OrderTimingType || (OrderTimingType = {}));
var OrderPaymentType;
(function (OrderPaymentType) {
  OrderPaymentType["onDelivery"] = "onDelivery";
  OrderPaymentType["online"] = "online";
})(OrderPaymentType || (OrderPaymentType = {}));

var OrderFeeType;
(function (OrderFeeType) {
  OrderFeeType["serviceFee"] = "serviceFee";
  OrderFeeType["coverCharge"] = "coverCharge";
  OrderFeeType["ifoodServiceFee"] = "ifoodServiceFee";
  OrderFeeType["ifoodSmallOrderFee"] = "ifoodSmallOrderFee";
})(OrderFeeType || (OrderFeeType = {}));

var OrderOrigin;
(function (OrderOrigin) {
  OrderOrigin["catalog"] = "catalog";
  OrderOrigin["panel"] = "panel";
  OrderOrigin["ifood"] = "ifood";
  OrderOrigin["aiquefome"] = "aiquefome";
})(OrderOrigin || (OrderOrigin = {}));

var OrderCounterResetPeriod;
(function (OrderCounterResetPeriod) {
  OrderCounterResetPeriod["never"] = "never";
  OrderCounterResetPeriod["daily"] = "daily";
  OrderCounterResetPeriod["monthly"] = "monthly";
  OrderCounterResetPeriod["yearly"] = "yearly";
})(OrderCounterResetPeriod || (OrderCounterResetPeriod = {}));

var OrdersDisplayType;
(function (OrdersDisplayType) {
  OrdersDisplayType["default"] = "default";
  OrdersDisplayType["list"] = "list";
  OrdersDisplayType["kanban"] = "kanban";
})(OrdersDisplayType || (OrdersDisplayType = {}));

var PaymentStatus;
(function (PaymentStatus) {
  PaymentStatus["pending"] = "pending";
  PaymentStatus["finalized"] = "finalized";
  PaymentStatus["canceled"] = "canceled";
  PaymentStatus["refunded"] = "refunded";
  PaymentStatus["refundedPending"] = "refundedPending";
})(PaymentStatus || (PaymentStatus = {}));

var PersonContactType;
(function (PersonContactType) {
  PersonContactType["email"] = "email";
  PersonContactType["phoneNumber"] = "phoneNumber";
  PersonContactType["whatsApp"] = "whatsApp";
})(PersonContactType || (PersonContactType = {}));
var PersonGender;
(function (PersonGender) {
  PersonGender["male"] = "male";
  PersonGender["female"] = "female";
  PersonGender["ratherNotSay"] = "ratherNotSay";
  PersonGender["custom"] = "custom";
})(PersonGender || (PersonGender = {}));
var PersonGenderToRefer;
(function (PersonGenderToRefer) {
  PersonGenderToRefer["male"] = "male";
  PersonGenderToRefer["female"] = "female";
  PersonGenderToRefer["other"] = "other";
})(PersonGenderToRefer || (PersonGenderToRefer = {}));
var PersonSortBy;
(function (PersonSortBy) {
  PersonSortBy["nameAscendant"] = "nameAscendant";
  PersonSortBy["nameDescendant"] = "nameDescendant";
  PersonSortBy["lastOrderDateAscendant"] = "lastOrderDateAscendant";
  PersonSortBy["lastOrderDateDescendant"] = "lastOrderDateDescendant";
  PersonSortBy["totalOrdersAscendant"] = "totalOrdersAscendant";
  PersonSortBy["totalOrdersDescendant"] = "totalOrdersDescendant";
})(PersonSortBy || (PersonSortBy = {}));

var PlanSupportType;
(function (PlanSupportType) {
  PlanSupportType["normal"] = "normal";
  PlanSupportType["priority"] = "priority";
  PlanSupportType["premium"] = "premium";
})(PlanSupportType || (PlanSupportType = {}));
var PlanRecurrencePaymentType;
(function (PlanRecurrencePaymentType) {
  PlanRecurrencePaymentType["free"] = "free";
  PlanRecurrencePaymentType["monthlyRecurrence"] = "monthlyRecurrence";
  PlanRecurrencePaymentType["annualRecurrence"] = "annualRecurrence";
})(PlanRecurrencePaymentType || (PlanRecurrencePaymentType = {}));
var PlanStatus;
(function (PlanStatus) {
  PlanStatus["ok"] = "ok";
  PlanStatus["warning"] = "warning";
  PlanStatus["blocked"] = "blocked";
})(PlanStatus || (PlanStatus = {}));

var PrinterType;
(function (PrinterType) {
  PrinterType[PrinterType["a4"] = 0] = "a4";
  PrinterType[PrinterType["thermal"] = 1] = "thermal";
  PrinterType[PrinterType["simplifiedThermal"] = 2] = "simplifiedThermal";
  PrinterType[PrinterType["group"] = 3] = "group";
})(PrinterType || (PrinterType = {}));
var PrinterTypeWithGroups;
(function (PrinterTypeWithGroups) {
  PrinterTypeWithGroups[PrinterTypeWithGroups["a4"] = 0] = "a4";
  PrinterTypeWithGroups[PrinterTypeWithGroups["thermal"] = 1] = "thermal";
  PrinterTypeWithGroups[PrinterTypeWithGroups["simplifiedThermal"] = 2] = "simplifiedThermal";
  PrinterTypeWithGroups[PrinterTypeWithGroups["group"] = 3] = "group";
})(PrinterTypeWithGroups || (PrinterTypeWithGroups = {}));

var DeactivatedStatusReason;
(function (DeactivatedStatusReason) {
  DeactivatedStatusReason["none"] = "none";
  DeactivatedStatusReason["outOfStock"] = "outOfStock";
  DeactivatedStatusReason["blocked"] = "blocked";
})(DeactivatedStatusReason || (DeactivatedStatusReason = {}));
var ItemType;
(function (ItemType) {
  ItemType["item"] = "item";
  ItemType["size"] = "size";
})(ItemType || (ItemType = {}));
var ItemPriceType;
(function (ItemPriceType) {
  ItemPriceType["price"] = "price";
  ItemPriceType["size"] = "size";
})(ItemPriceType || (ItemPriceType = {}));
var ItemImageStatus;
(function (ItemImageStatus) {
  ItemImageStatus["activated"] = "activated";
  ItemImageStatus["deactivated"] = "deactivated";
  ItemImageStatus["deleted"] = "deleted";
})(ItemImageStatus || (ItemImageStatus = {}));
var ItemPriceStatus;
(function (ItemPriceStatus) {
  ItemPriceStatus["activated"] = "activated";
  ItemPriceStatus["deactivated"] = "deactivated";
  ItemPriceStatus["deleted"] = "deleted";
})(ItemPriceStatus || (ItemPriceStatus = {}));

var PromotionStatus;
(function (PromotionStatus) {
  PromotionStatus["activated"] = "activated";
  PromotionStatus["deactivated"] = "deactivated";
  PromotionStatus["deleted"] = "deleted";
})(PromotionStatus || (PromotionStatus = {}));

var PublicUserAddressType;
(function (PublicUserAddressType) {
  PublicUserAddressType["residential"] = "residential";
  PublicUserAddressType["commercial"] = "commercial";
})(PublicUserAddressType || (PublicUserAddressType = {}));

var ReferralStatus;
(function (ReferralStatus) {
  ReferralStatus["pending"] = "pending";
  ReferralStatus["accepted"] = "accepted";
  ReferralStatus["rewarded"] = "rewarded";
  ReferralStatus["rejected"] = "rejected";
})(ReferralStatus || (ReferralStatus = {}));

var SignInProvider;
(function (SignInProvider) {
  SignInProvider["password"] = "password";
  SignInProvider["google"] = "google";
  SignInProvider["facebook"] = "facebook";
  SignInProvider["apple"] = "apple";
})(SignInProvider || (SignInProvider = {}));

var OrderStatus;
(function (OrderStatus) {
  OrderStatus["pending"] = "pending";
  OrderStatus["accepted"] = "accepted";
  OrderStatus["finished"] = "finished";
  OrderStatus["canceled"] = "canceled";
  OrderStatus["delivered"] = "delivered";
  OrderStatus["takeout"] = "takeout";
  OrderStatus["preparing"] = "preparing";
})(OrderStatus || (OrderStatus = {}));

var SurveyQuestionCategory;
(function (SurveyQuestionCategory) {
  SurveyQuestionCategory["order"] = "order";
  SurveyQuestionCategory["deliveryTime"] = "deliveryTime";
  SurveyQuestionCategory["service"] = "service";
  SurveyQuestionCategory["price"] = "price";
  SurveyQuestionCategory["environment"] = "environment";
  SurveyQuestionCategory["others"] = "others";
})(SurveyQuestionCategory || (SurveyQuestionCategory = {}));

var TimingTypes;
(function (TimingTypes) {
  TimingTypes["immediate"] = "immediate";
  TimingTypes["scheduled"] = "scheduled";
})(TimingTypes || (TimingTypes = {}));

var UnityOfTime;
(function (UnityOfTime) {
  UnityOfTime["minute"] = "minute";
  UnityOfTime["hour"] = "hour";
  UnityOfTime["day"] = "day";
})(UnityOfTime || (UnityOfTime = {}));

var FeedbackType;
(function (FeedbackType) {
  FeedbackType["complaint"] = "complaint";
  FeedbackType["suggestion"] = "suggestion";
  FeedbackType["praise"] = "praise";
  FeedbackType["nps"] = "nps";
})(FeedbackType || (FeedbackType = {}));

var NotificationStatus;
(function (NotificationStatus) {
  NotificationStatus["notRead"] = "notRead";
  NotificationStatus["read"] = "read";
  NotificationStatus["expired"] = "expired";
})(NotificationStatus || (NotificationStatus = {}));
var NotificationType;
(function (NotificationType) {
  NotificationType["info"] = "info";
  NotificationType["warning"] = "warning";
  NotificationType["critical"] = "critical";
})(NotificationType || (NotificationType = {}));

var PermissionLevel;
(function (PermissionLevel) {
  PermissionLevel["nothing"] = "nothing";
  PermissionLevel["read"] = "read";
  PermissionLevel["write"] = "write";
})(PermissionLevel || (PermissionLevel = {}));
var PermissionType;
(function (PermissionType) {
  PermissionType["cashFlowSettings"] = "cashFlowSettings";
  PermissionType["permissions"] = "permissions";
  PermissionType["reportsGeneral"] = "reportsGeneral";
  PermissionType["reportsOrders"] = "reportsOrders";
  PermissionType["reportsClients"] = "reportsClients";
  PermissionType["reportsProducts"] = "reportsProducts";
  PermissionType["reportsSurvey"] = "reportsSurvey";
  PermissionType["reportsDeliveries"] = "reportsDeliveries";
  PermissionType["deliveryMen"] = "deliveryMen";
})(PermissionType || (PermissionType = {}));

var OrderNotificationType;
(function (OrderNotificationType) {
  OrderNotificationType[OrderNotificationType["order"] = 0] = "order";
  OrderNotificationType[OrderNotificationType["orderStatusUpdate"] = 1] = "orderStatusUpdate";
})(OrderNotificationType || (OrderNotificationType = {}));

export { BotStatus, CardFlagsType, CashFlowStatus, CategoryOperationMethod, CategoryType, ChargeType, CompletedLoyaltyPlanSortBy, ConfirmationStatus, DayOfTheWeek, DeactivatedStatusReason, DeliveryFeeType, DeliveryStatusTypes, DeliveryType, DigitalWalletType, DiscountCodeStatus, DiscountCodeType, DiscountTarget, DiscountValueType, DocumentType, FeedbackType, GenericStatus, IFoodState, IntegrationStatus, ItemDisplayModeInCategory, ItemImageStatus, ItemPriceStatus, ItemPriceType, ItemType, ManualCloseMode, ManualOpenMode, MercadoPagoIntegrationsInfoStatus, MovementType, NotificationStatus, NotificationType, OnlinePaymentOrderBehavior, OpenCloseBehavior, OpenCloseHourStatus, OperationType, OptionalOptionType, OrderCounterResetPeriod, OrderFeeType, OrderItemProductionStatus, OrderNotificationType, OrderOrigin, OrderPaymentType, OrderStatus, OrderTimingType, OrdersDisplayType, PaymentSettingsTypes, PaymentStatus, PaymentType, PermissionLevel, PermissionType, PersonContactType, PersonGender, PersonGenderToRefer, PersonLoyaltyPlanSortBy, PersonSortBy, PlanRecurrencePaymentType, PlanStatus, PlanSupportType, PointOrigin, PrinterType, PrinterTypeWithGroups, PromotionStatus, PublicUserAddressType, RedeemableStatus, ReferralStatus, SignInProvider, StatusType, Step, SurveyQuestionCategory, TimingTypes, TypeCardFlag, TypeOption, UnityOfTime, VehicleType, clientType, neighborhoodCityState, streetAndNumber, streetNumberNeighborhood };
//# sourceMappingURL=lets-eat-types.esm.js.map
